<template>
  <div class="cbg-white-container">
    <div class="profile-info">
      <div class="pro-info-main">
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Name</b>
            </h5>
            <p>{{ data.full_name }}</p>
          </div>
        </div>
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Reg No.</b>
            </h5>
            <p>{{ data.council_registration_number }}</p>
          </div>
        </div>
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Experience</b>
            </h5>
            <p>{{ data.number_of_years_practicing }} years</p>
          </div>
        </div>
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Qualification</b>
            </h5>
            <p v-for="(qual, index) in data.highest_qualification" :key="index">{{ qual }}</p>
          </div>
        </div>
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Specialities</b>
            </h5>
            <p>{{ data.specialities }}</p>
          </div>
        </div>
        <div class="profile-info-list" v-if="data.online_consultation.is_participating">
          <div>
            <h5>
              <b>Online Consultation</b>
            </h5>
            <p>Yes</p>
          </div>
        </div>
        <div class="profile-info-list" v-if="data.home_visit.is_available_for_home_visit">
          <div>
            <h5>
              <b>Home Visit</b>
            </h5>
            <p>Yes</p>
          </div>
        </div>
        <div class="profile-info-list" v-if="data.is_available_for_free_consultation">
          <div>
            <h5>
              <b>Free Consultancy</b>
            </h5>
            <p>Yes</p>
          </div>
        </div>
      </div>
      <div class="pro-info-main">
        <div class="profile-info-list address-card" v-for="(item, index) in list" :key="index">
          <div>
            <h5>
              <b>{{ item.general.name }}</b>
            </h5>
          </div>
          <div>
            <p v-if="item.general.address.address_line_one">
              {{ item.general.address.address_line_one }},
              <br />
              {{ item.general.address.address_line_two }}
            </p>
            <p v-else>{{ item.general.address.address_line_two }}</p>
          </div>
          <div>
            <p>
              <b v-if="item.clinic.days != 'Customize'">Timings- {{ item.clinic.days }}</b>
              <b v-if="item.clinic.days == 'Customize'">Timings- {{ getDay(item.clinic) }}</b>
              <a>
                <div
                  v-if="
                    item.clinic.days != 'Customize' &&
                      item.clinic.timings.length > 0
                  "
                >
                  <div>
                    <p>
                      {{ getTime(item.clinic.timings[0].time_open[0]) }} -
                      {{ getTime(item.clinic.timings[0].time_close[0]) }}
                    </p>
                    <a @click="openTime(item.clinic)">View More Timing</a>
                  </div>
                </div>
                <div v-else>
                  <div>
                    <p>
                      {{ getTime(item.clinic.timings[0].time_open[0]) }} -
                      {{ getTime(item.clinic.timings[0].time_close[0]) }}
                    </p>
                    <a @click="openTime(item.clinic)">View More Timing</a>
                  </div>
                </div>
              </a>
              <!-- <b>Timings :</b> 9:30 AM to 7:30 PM
              <a href>View More Timing</a>-->
            </p>
          </div>
          <div>
            <h4>&#8377; {{ item.clinic.fees_first_visit.amount }}</h4>
            <p>First Visit Fee</p>
          </div>
          <div>
            <h4>&#8377; {{ item.clinic.fees_followup.amount }}</h4>
            <p>Follow Up Fee</p>
          </div>
        </div>
      </div>
    </div>
    <CModal
      :show.sync="viewTime"
      :no-close-on-backdrop="true"
      :centered="true"
      title="History"
      size="lg"
      color="dark"
      :details="timingData"
    >
      <div class="form-group" v-for="(log, index) in timingData.timings" :key="index">
        <div class="row">
          <div class="col-sm-12 nopad visit-timing-mod">
            <div class>
              <p>{{ log.day }}</p>
            </div>
            <div class="visittiming" v-for="(openTime, k) in log.time_open" :key="k">
              <p>
                {{ getTime(openTime) }} to
                {{ getTime(log.time_close[k]) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <template #header>
        <h6 class="modal-title">More Timing</h6>
        <CButtonClose @click="viewTime = false" />
      </template>
      <template #footer>
        <CButton @click="viewTime = false" color="danger">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  props: {
    data: Object,
    list: Array
  },
  data() {
    return {
      dayJS,
      viewTime: false,
      timingData: {},
    };
  },
  methods: {
    getTime(time) {
      return dayJS(time, "hh:mm").format("h:mm A");
    },
    getDay(details) {
      let str = details.timings.map(a => a.day).join(",");
      str = str.split(",");
      str = str.map(day => day.substr(0, 3)).join(", ");
      return str;
    },
    openTime(details) {
      this.viewTime = true;
      this.timingData = details;
    }
  }
};
</script>
